var _rect, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 7.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 31,
    r: 21,
    fill: "url(#paint0_linear_2337_28739)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8206 37.4223L38.7534 31.4951H32.9178V27.6505C32.9178 26.0286 33.7315 24.4466 36.3452 24.4466H39V19.4005C39 19.4005 36.5918 19 34.2904 19C29.4823 19 26.3425 21.8394 26.3425 26.9777V31.4951H21V37.4223H26.3425V51.7517C27.4151 51.9159 28.5124 52 29.6302 52C30.748 52 31.8453 51.9159 32.9178 51.7517V37.4223H37.8206Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2337_28739",
    x1: 30,
    y1: 10,
    x2: 30,
    y2: 51.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.a62c02edfd3c0981052bbd8494c45462.svg";
export { ForwardRef as ReactComponent };